import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
// Modals
import { AlertasModales } from '../../../helpers/alertasModales';
import { Helper } from '../../../helpers/helper';
import { FormGroup, FormControl, Validators } from '@angular/forms';

// Servicios
import { ClientesService } from '../../../services/Clientes.service';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { PrestamosService } from '../../../services/prestamos.service';
import { Factura } from '../../../interfaces/prestamos.interface';
// use jquery
declare var $: any;
@Component({
  selector: 'app-nuevo',
  templateUrl: './nuevo.component.html',
  styles: []
})
export class NuevoComponent implements OnInit, AfterViewInit {
  form: FormGroup;
  datosFactura: Factura;
  prestamo: any;
  Math: Math;
  cedulas: Observable<Array<any>>;
  loadingRnc = false;
  loaded = false;
  loading = false;
  now = new Date(this.helper.getDate());
  constructor(private modals: AlertasModales,
              private clienteService: ClientesService,
              private empleadoService: EmpleadosServicio,
              private prestamoService: PrestamosService,
              private helper: Helper) {
    this.Math = Math;

    // Inicializar formulario
    this.form = new FormGroup({
      'cedula': new FormControl('', Validators.required),
      'nombre': new FormControl({value: '', disabled: true}),
      'fecha_pago': new FormControl({
        year: this.now.getFullYear(),
        month: this.now.getMonth() + 1,
        day: this.now.getDate()}),
      'telefono': new FormControl({value: '', disabled: true}),
      'ID_CLIENTE': new FormControl(''),
      'ID_PRESTAMO': new FormControl('')
    });
    this.cedulasInit();
  }

  ngOnInit() {
    if (localStorage.getItem('realizar_cobro')) {
      const data = JSON.parse(localStorage.getItem('realizar_cobro'));
      this.form.get('cedula').setValue(data.cedula);
      this.form.get('nombre').setValue(data.nombre);
      this.form.get('telefono').setValue(data.telefono);
      this.form.get('ID_CLIENTE').setValue(data.ID_CLIENTE);
      this.clienteService.obtenerPrestamoPorId(data.ID_PRESTAMO).subscribe(res => {
        this.form.get('ID_PRESTAMO').setValue(data.ID_PRESTAMO);
        this.prestamo = res;
        localStorage.removeItem('realizar_cobro');
        this.reciboIngreso();
      });
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.loaded = true;
    }, 1);
  }

  private initPrestamoCliente(ID_CLIENTE): void {
    this.loaded = false;
    this.clienteService.obtenerPrestamoPorId(ID_CLIENTE).subscribe(data => {
      setTimeout(() => {
        this.loaded = true;
      }, 1);
      if (data) {

        this.form.get('ID_PRESTAMO').setValue(data.ID_PRESTAMO);
        this.prestamo = data;
      }
    });
  }

  busquedaAvanzada() {
    this.modals.busquedaAvanzadaClientesNgbModal('cobro').then((res: any) => {
      if (res) {
        const now = new Date(this.helper.getDate());
        this.prestamo = null;
        this.form.get('cedula').setValue(res.cedula);
        this.form.get('nombre').setValue(res.nombre + ' ' + res.apellido);
        this.form.get('telefono').setValue(res.telefono);
        this.form.get('ID_CLIENTE').setValue(res.id);
        this.form.get('ID_PRESTAMO').setValue(res.ID_P);
        this.initPrestamoCliente(res.ID_P);
      }
    });
  }

  reciboIngreso() {
    const fecha = this.form.get('fecha_pago').value;
    const prestamo = {
      ID_EMPLEADO: this.empleadoService.datosEmpleado.ID_EMPLEADO,
      cliente: {
        nombre: this.form.get('nombre').value,
        telefono: this.form.get('telefono').value,
        ID_CLIENTE: this.form.get('ID_CLIENTE').value,
        ID_PRESTAMO: this.form.get('ID_PRESTAMO').value
      },
      cuotas: [],
      ID_PRESTAMO: this.prestamo.ID_PRESTAMO,
      capital: this.prestamo.capital,
      totalInteres: this.prestamo.totalInteres,
      total_cuotas: this.prestamo.total_cuotas,
      total_pagado: this.prestamo.total_pagado,
      fecha_inicia: this.prestamo.fecha_inicio,
      fecha_vence: this.prestamo.fecha_vence,
      fecha_pago: this.form.get('fecha_pago').value
    };

    for (let i = 0; i < this.prestamo.cuotas.length; i++) {
      if (this.prestamo.cuotas[i].estado !== 2) {
        prestamo.cuotas.push(this.prestamo.cuotas[i]);
      }
    }

    this.modals.cobroPersonalizadoNgbModal(prestamo).then((res: any) => {
      if (res ) {
        if (res.hasOwnProperty('err')) {
            if ((res.err.hasOwnProperty('status') && res.err.status === 0) ||
            (res.err.hasOwnProperty('name') && res.err.name === 'TimeoutError')) {
              this.modals.validacionesModalJquery('Error al comunicarse con el servidor. Favor de verificar su conexión a internet', '',
                'orange',
                'modern',
                false,
                'fa fa-wifi');
            } else {
              this.modals.validacionesModalJquery('Ups, ha ocurrido un error inesperado', res.err, 'red', 'modern');
            }

        } else {
          console.log('ID_PRESTOAMO: ' + this.form.get('ID_PRESTAMO').value);

          this.clienteService.obtenerPrestamoPorId(this.form.get('ID_PRESTAMO').value).subscribe(data => {
            this.prestamo = data;
          });
          this.modals.correctoModalJquery('Operación realizada éxitosamente', 'green', 'modern', 'fa fa-money');
        }
      }
    });
  }

  realizarPago(data, i) {
    this.loading = true;
    const fecha = this.form.get('fecha_pago').value;
    const d = new Date();
    const cuota = {
      ID_EMPLEADO: this.empleadoService.datosEmpleado.ID_EMPLEADO,
      total_cuotas: this.prestamo.cuotas.length,
      cuota: data,
      fecha_pago:  `${fecha.year}-${fecha.month}-${fecha.day} ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`
    };
    Object.defineProperty(data, 'fecha_pago', { value: cuota.fecha_pago, enumerable: true });
    let check = false;
    for (let k = 0; k < i; k++) {
      if (this.prestamo.cuotas[k].estado !== 2) {
        check = true;
        break;
      }
    }
    if (check && i !== 0) {
      this.modals.validacionesModalJquery('Error',
      'No puedes pagar esta cuota. Debido a que la cuota anterior no ha sido pagada.', 'red', 'modern');
      setTimeout(() => this.loading = false, 1);
    } else {
      let html =
      `<p>¿Estas seguro de <b>cobrar</b>
       la cuota <b>#${data.numero_cuota}</b>
        del préstamo <b>#${this.form.get('ID_PRESTAMO').value}</b> del cliente <b>${this.form.get('nombre').value}</b>?</p>`;
        html += `<div class="row">`;
        html += `<div class="col-md-4"><strong>Cuota: </strong><span>RD$ ${data.monto_cuota - data.total_pagado}</span></div>`;
        html += `<div class="col-md-4"><strong>Mora: </strong><span>RD$ ${parseFloat(data.mora).toFixed(2)}</span></div>`;
        html += `<div class="col-md-4"><strong>Total: </strong>
        <span>RD$ ${parseFloat(data.monto_cuota - data.total_pagado + data.mora).toFixed(2)}</span></div>`;
        html += `</div>`;
      this.modals.confirmModalJquery('Cobro Cuota', html, 'orange', 'material').then(resp => {
        if (resp && resp === 'SI') {

          this.prestamoService.realizarPago(cuota, false).subscribe((res: any) => {
            setTimeout(() => this.loading = false, 1);
            if (res) {
              this.clienteService.obtenerPrestamoPorId(this.form.get('ID_PRESTAMO').value).subscribe(result => {
                this.prestamo = result;
              });
              this.registrarRecibo(data);
              this.modals.correctoModalJquery('Operación realizada éxitosamente', 'green', 'modern', 'fa fa-money');
            }
          }, err => {
            if (err) {
              setTimeout(() => this.loading = false, 1);
              if ((err.hasOwnProperty('status') && err.status === 0) || (err.hasOwnProperty('name') && err.name === 'TimeoutError')) {
                this.modals.validacionesModalJquery('Error al comunicarse con el servidor. Favor de verificar su conexión a internet', '',
                  'orange',
                  'modern',
                  false,
                  'fa fa-wifi');
              } else {
                this.modals.validacionesModalJquery('Ups ha ocurrido un error inesperado', err, 'red', 'modern');
              }
            }
          });
        } else {
          setTimeout(() => this.loading = false, 1);
        }
      });
    }
  }


  // Cargar datos cliente por su cedula
  clientePorCedula(ID) {
    this.loadingRnc = true;
    this.clienteService.obtenerClientePorID(ID).subscribe((res: any) => {
      this.form.get('cedula').setValue(res.cedula);
      this.form.get('nombre').setValue(`${res.nombre} ${res.apellido}`);
      this.form.get('telefono').setValue(res.telefono);
      this.form.get('ID_CLIENTE').setValue(res.ID_CLIENTE);
      this.clienteService.obtenerPrestamoPorId(this.form.get('ID_PRESTAMO').value).subscribe(data => {
        this.form.get('ID_PRESTAMO').setValue(data.ID);
        this.prestamo = data;
      });
      this.loadingRnc = false;
    });
  }


  registrarPrestamo() {
    localStorage.setItem('nuevoCliente', this.form.get('cedula').value);
  }

  // Inicializar la variable cedulas
  cedulasInit() {
    this.cedulas = this.prestamoService.obtenerRncClientes();
  }

  private registrarRecibo(data): void {
    /* ============================================================================
      Inicializar la variable datosFactura para registrar el recibo en la DB-LOCAL
      ============================================================================
    */
    let fecha = this.form.get('fecha_pago').value;
    fecha = fecha.year + '-' + fecha.month + '-' + fecha.day;
    const d = new Date(fecha);
    const t = new Date(this.helper.getDate());
    const date = (d.getMonth() + 1) + '' +
                  d.getDate()  + '' +
                  t.getHours() + '' +
                  t.getMinutes() + '' +
                  t.getSeconds();
    this.datosFactura = {
      ID_RECIBO: date + '-' + this.prestamo.ID_PRESTAMO +  '-' +  data.numero_cuota,
      negocio: '',
      ID_CLIENTE: this.form.get('ID_CLIENTE').value,
      ID_PRESTAMO: this.prestamo.ID_PRESTAMO,
      fecha_inicia: this.prestamo.fecha_inicio.split('T')[0],
      fecha_termina: this.prestamo.fecha_vence.split('T')[0],
      ID_EMPLEADO: this.empleadoService.datosEmpleado.ID_EMPLEADO,
      monto_pagado: Math.ceil(data.monto_cuota - data.total_pagado),
      fecha_registro: data.fecha_pago,
      cuotas: [{
        ID_CUOTA: data.ID_CUOTA,
        monto_pagado: Math.ceil(data.monto_cuota - data.total_pagado),
        numero_cuota: data.numero_cuota,
        mora: data.mora,
        tipo: (data.monto_cuota - data.total_pagado !== data.monto_cuota ? 'Completivo' : 'Pago')
      }]
    };

    this.prestamoService.registrarRecibo(this.datosFactura)
    .subscribe();
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/cobros/nuevo/nuevo.component.ts